export const PermissionCustomer = {
    PUT: "change_customer",
    POST: "add_customer",
    VIEW: "view_customer",
    DELETE: "delete_customer",
    EXPORT: "can_export_customer",
    IMPORT: "can_import_customer"
};